import { DatePicker, Row, Select } from 'antd';
import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import {
	getDefaultDateRanges,
	getTimeZoneOptions,
	myTimeZone,
} from '../../utils/DataFormatterUtils';
import { FILTER_CONFIG_NAMES } from '../../utils/DataConstants';
import 'moment-timezone'; // loads zone data for the .tz() calls below

const RANGE_PICKER_DATE_FORMAT = 'MM-DD-YYYY';

require('./OWDateRangePicker.less');

const OWDateRangePicker: FC<any> = ({
	value,
	onChange,
	ranges = getDefaultDateRanges(),
	disabledDate = () => {},
	showTimeZone = false,
	timeZones,
}): React.ReactElement => {
	const timeZoneOptions = useMemo(() => getTimeZoneOptions(timeZones), [timeZones]);

	const startDate = useMemo(() => value && value.length > 1 && value[0], [value]);
	const endDate = useMemo(() => value && value.length > 1 && value[1], [value]);
	const initialTimeZone = useMemo(
		() => (value && value.length > 2 && value[2]) || myTimeZone(),
		[value]
	);

	const [timeZone, setTimeZone] = useState(initialTimeZone);

	const vals = value && [startDate, endDate];

	const handleTimeZoneChange = (tz) => {
		setTimeZone(tz);
		const startDate = (vals && vals[0] && vals[0].tz(tz, true)) || undefined;
		const endDate = (vals && vals[1] && vals[1].tz(tz, true)) || undefined;
		(startDate || endDate) && onChange([startDate, endDate], tz);
	};

	return (
		<Row style={{ flex: 1 }}>
			<DatePicker.RangePicker
				key={
					startDate && endDate ? startDate.format('YYMMDD') + endDate.format('YYMMDD') : undefined
				}
				value={vals}
				ranges={ranges}
				format={RANGE_PICKER_DATE_FORMAT}
				showTime={false}
				onChange={(v) => {
					onChange(v, timeZone);
				}}
				allowEmpty={[true, true]}
				disabledDate={disabledDate}
				style={showTimeZone ? { borderRadius: '2px 0px 0px 2px' } : {}}
			/>
			{showTimeZone ? (
				<Select
					className="tz-select"
					style={{
						display: 'inline-flex',
						alignItems: 'center',
						whiteSpace: 'nowrap',
						width: 75,
						marginLeft: -1,
						borderRadius: '0px 2px 2px 0px',
					}}
					defaultValue={initialTimeZone}
					onSelect={handleTimeZoneChange}
				>
					{timeZoneOptions.map((option) => (
						<Select.Option key={option.value} value={option.value} label={option.label}>
							{option.label}
						</Select.Option>
					))}
				</Select>
			) : null}
		</Row>
	);
};

export default OWDateRangePicker;
